module.exports = __webpack_public_path__ + "static/media/logo_login_metallic.9e56fe22.png";